import { configureStore } from "@reduxjs/toolkit";
import auth from "./authStore";
import checkoutStore from "./checkoutStore";
import storageUnit from "./storageFacilityStore";

export const store = configureStore({
  reducer: {
    storageUnit,
    auth,
    checkoutStore,
  },
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;
